<template>
    <div>
        <div class="app-title">
            <em-view-title></em-view-title>
        </div>
        <section class="app-content">
            <div class="card-columns">
                <EmCardRouter v-for="cardData in this.routerCards" :key="cardData.id"
                              :cardData="cardData"></EmCardRouter>
            </div>
        </section>

    </div>
</template>


<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import EmCardRouter from "@/components/em/EmCard/Router";
    import EmViewTitle from "@/components/em/EmViewTitle";

    export default {
        name: "emProjectCardRouters",
        components: {EmCardRouter,EmViewTitle},
        data: function () {
            return {
                show: true
            };
        },
        methods: {
            handleClick: function () {
                this.show = !this.show;
            },
            ...mapActions("emMenu", ["retrieveForRouterCards"]),
            ...mapMutations("emMenu", ["setEmMenuBadge", "setStateAttribute"])
        },
        computed: {
            ...mapState({
                routerCards: state => state.emMenu.routerCards
            })
        },
        mounted() {
            if (this.$route.query.menuId) {
                this.retrieveForRouterCards(this.$route.query.menuId);
            }
        }
    };
</script>


